import store from '@/store'

export default {
  get: (key) => {
    return store.getters.getFromSession(key)
  },
  set: (key, value) => {
    return store.dispatch('addToSession', { key, value })
  },
  del: function (key) {
    return store.dispatch('removeFromSession', key)
  },
  pop: function (key) {
    const value = this.get(key)
    this.del(key)
    return value
  }
}
